<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->
<div>
  <fab-loading-spinner color="primary" [hidden]="!showSpinner"></fab-loading-spinner>
</div>
<div id="brand-family-container">

  <div id="header-container">
    <div>
      <h1 id="header-text">Manage Brand Family/GSEG/PROP SEG</h1>
    </div>
  </div>
  <div class="top-body default-padding flex-gap">
    <div id="option-container" class="flex-column flex-gap">
      <div id="first-row">
        <div>
          <mat-form-field class="option-dropdown" appearance="fill" subscriptSizing="dynamic">
            <mat-label class="asterisk--before">Regions</mat-label>
            <mat-select [(ngModel)]="selectedRegion" (selectionChange)="onChange('REGION')">
              <mat-option *ngFor="let region of regionsList" [value]="region">{{ region }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div>
          <mat-form-field class="option-dropdown" subscriptSizing="dynamic"
                          [matTooltip]="getTooltipText(subregions.selectedOptions)">
            <mat-label class="asterisk--before">Subregion(s)</mat-label>
            <fab-multiselect
              name="subregions"
              [(ngModel)]="subregions.selectedOptions"
              (ngModelChange)="onChange('SUBREGION')"
              [options]="subregions.options"
              [disabled]="isListEmpty(subregions.options)">
            </fab-multiselect>
          </mat-form-field>
        </div>

        <div>
          <mat-form-field class="option-dropdown" subscriptSizing="dynamic"
                          [matTooltip]="getTooltipText(planningMarkets.selectedOptions)">
            <mat-label class="asterisk--before">Planning Market(s)</mat-label>
            <fab-multiselect
              name="planningMarkets"
              [(ngModel)]="planningMarkets.selectedOptions"
              (ngModelChange)="onChange('PLNGMKT')"
              [options]="planningMarkets.options"
              [disabled]="isListEmpty(planningMarkets.options)">
            </fab-multiselect>
          </mat-form-field>
        </div>

        <div>
          <mat-form-field class="option-dropdown" subscriptSizing="dynamic"
                          [matTooltip]="getTooltipText(marketDivisions.selectedOptions)">
            <mat-label>Market Divisions(s)</mat-label>
            <fab-multiselect
              name="marketDivisions"
              [(ngModel)]="marketDivisions.selectedOptions"
              (ngModelChange)="onChange('MKTDIV')"
              [options]="marketDivisions.options"
              [disabled]="isListEmpty(marketDivisions.options)">
            </fab-multiselect>
          </mat-form-field>
        </div>

        <div>
          <mat-form-field class="option-dropdown" subscriptSizing="dynamic"
                          [matTooltip]="getTooltipText(brands.selectedOptions)">
            <mat-label>Brand(s)</mat-label>
            <fab-multiselect
              name="brands"
              [(ngModel)]="brands.selectedOptions"
              (ngModelChange)="onChange('BRAND')"
              [options]="brands.options"
              [disabled]="isListEmpty(brands.options)">
            </fab-multiselect>
          </mat-form-field>
        </div>

        <div>
          <mat-form-field class="option-dropdown" subscriptSizing="dynamic"
                          [matTooltip]="getTooltipText(localBrands.selectedOptions)">
            <mat-label>Local Brand(s)</mat-label>
            <fab-multiselect
              name="localBrands"
              [(ngModel)]="localBrands.selectedOptions"
              (ngModelChange)="onChange('LBRAND')"
              [options]="localBrands.options"
              [disabled]="isListEmpty(localBrands.options)">
            </fab-multiselect>
          </mat-form-field>
        </div>
      </div>
      <div id="second-row">
        <div>
          <mat-form-field class="option-dropdown" subscriptSizing="dynamic"
                          [matTooltip]="getTooltipText(programCodes.selectedOptions)">
            <mat-label>Program Code(s)</mat-label>
            <fab-multiselect
              name="programCodes"
              [(ngModel)]="programCodes.selectedOptions"
              (ngModelChange)="onChange('PRGMCODE')"
              [options]="programCodes.options"
              [disabled]="isListEmpty(programCodes.options)">
            </fab-multiselect>
          </mat-form-field>
        </div>

        <div>
          <mat-form-field class="option-dropdown" subscriptSizing="dynamic"
                          [matTooltip]="getTooltipText(styleCodes.selectedOptions)">
            <mat-label>Style Code(s)</mat-label>
            <fab-multiselect
              name="styleCodes"
              [(ngModel)]="styleCodes.selectedOptions"
              (ngModelChange)="onChange('STYLECODE')"
              [options]="styleCodes.options"
              [disabled]="isListEmpty(styleCodes.options)">
            </fab-multiselect>
          </mat-form-field>
        </div>

        <div>
          <mat-form-field class="option-dropdown" subscriptSizing="dynamic"
                          [matTooltip]="getTooltipText(bodyStyles.selectedOptions)">
            <mat-label>Body Style(s)</mat-label>
            <fab-multiselect class="fixed-width"
                             name="bodyStyles"
                             [(ngModel)]="bodyStyles.selectedOptions"
                             (ngModelChange)="onChange('BODYSTYLE')"
                             [options]="bodyStyles.options"
                             [disabled]="isListEmpty(bodyStyles.options)">
            </fab-multiselect>
          </mat-form-field>
        </div>

        <div>
          <mat-form-field class="option-dropdown" subscriptSizing="dynamic"
                          [matTooltip]="getTooltipText(brandFams.selectedOptions)">
            <mat-label>BrandFam(s)</mat-label>
            <fab-multiselect
              name="brandFams"
              [(ngModel)]="brandFams.selectedOptions"
              (ngModelChange)="onChange('BRANDFAM')"
              [options]="brandFams.options"
              [disabled]="isListEmpty(brandFams.options)">
            </fab-multiselect>
          </mat-form-field>
        </div>

        <div>
          <mat-form-field class="option-dropdown" subscriptSizing="dynamic"
                          [matTooltip]="getTooltipText(globalSegments.selectedOptions)">
            <mat-label>Global Segment(s)</mat-label>
            <fab-multiselect
              name="globalSegments"
              [(ngModel)]="globalSegments.selectedOptions"
              (ngModelChange)="onChange('GSEG')"
              [options]="globalSegments.options"
              [disabled]="isListEmpty(globalSegments.options)">
            </fab-multiselect>
          </mat-form-field>
        </div>

        <div>
          <mat-form-field class="option-dropdown" subscriptSizing="dynamic"
                          [matTooltip]="getTooltipText(propSegments.selectedOptions)">
            <mat-label>Propulsion Segment(s)</mat-label>
            <fab-multiselect
              name="propSegments"
              [(ngModel)]="propSegments.selectedOptions"
              [options]="propSegments.options"
              [disabled]="isListEmpty(propSegments.options)">
            </fab-multiselect>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div id="checks-and-buttons" class="flex-row flex-gap ">

      <div class="button-container flex-gap">
        <div id="report-buttons" class="flex-row flex-gap">
          <button id="get-filtered-report-button" mat-flat-button color="primary" class="action-button"
                  (click)="filteredReportOnClick()"
                  [disabled]="isListEmpty(propSegments.selectedOptions)">
            Get Filtered Report
          </button>
          <app-export-button id="export-button" class="action-button"
                             [disabled]="(!resultData || resultData.length === 0) && !worksheetExportRequest"
                             [excelExportService]="excelService"
                             [worksheetExportRequest]="worksheetExportRequest">
            Export
          </app-export-button>
        </div>
        <div class="buttons-and-required flex-column">
          <div id="filter-buttons" class="flex-row flex-gap">
            <button id="select-everything-button" mat-flat-button color="primary" class="action-button"
                    (click)="selectEverything()"
                    [disabled]="isListEmpty(planningMarkets.selectedOptions)">
              Select All
            </button>
            <button id="reset-filters-button" mat-flat-button color="primary" class="action-button"
                    (click)="resetFilters()">
              Reset Filters
            </button>
          </div>
          <span class="required-text">*Required for Select All</span>
          <mat-checkbox [(ngModel)]="showPlanningMarket">
            Show Planning Market
          </mat-checkbox>
        </div>
      </div>
      <div id="edit-container" class="flex-row flex-gap" *ngIf="resultData.length > 0">
        <mat-radio-group id="edit-radio-group" [(ngModel)]="selectedEditCategory"
                         class="flex-column"
                         (change)="getUpdateDropdownList()">
          <mat-radio-button [value]="0">
            BrandFam
          </mat-radio-button>
          <mat-radio-button [value]="1" [disabled]="isGsegBtnDisabled">
            Global Segment
          </mat-radio-button>
          <mat-radio-button [value]="2" [disabled]="isPropBtnDisabled">
            Propulsion Segment
          </mat-radio-button>
        </mat-radio-group>
      </div>
      <div id="update-actions" class="flex-column flex-gap" [hidden]="selectedEditCategory === -1">
        <button id="update-button" mat-flat-button color="primary" class="action-button"
                (click)="updateBrandfamGSegPropSeg()"
                [disabled]="(selectedEditOption.length === 0)">
          Update
        </button>
        <div id="update-dropdown" [hidden]="selectedEditCategory === -1">
          <mat-form-field appearance="fill" [hidden]="selectedEditCategory === 0">
            <mat-select [(ngModel)]="selectedEditOption" [disabled]="isListEmpty(editOptions)">
              <mat-option *ngFor="let option of editOptions" [value]="option">{{ option }}</mat-option>
            </mat-select>
          </mat-form-field>
          <div [hidden]="selectedEditCategory !== 0">
            <mat-form-field appearance="fill">
              <input type="text" id="brandfam-input"
                     matInput
                     [(ngModel)]="selectedEditOption"
                     [formControl]="inputControl"
                     [matAutocomplete]="autoBrandFam"/>
            </mat-form-field>
            <mat-autocomplete #autoBrandFam="matAutocomplete">
              <mat-option *ngFor="let option of filteredOptions | async"
                          [value]="option">{{ option }}
              </mat-option>
            </mat-autocomplete>
          </div>
        </div>
      </div>

    </div>

  </div>

  <!--  Tables-->
  <div class="content-height">
    <hr>
    <!--    Main Option Table-->

    <ag-grid-angular *ngIf="resultData.length > 0"
                     style="height: 100%;"
                     class="ag-theme-quartz"
                     [rowData]="resultData"
                     [columnDefs]="columnDefs"
                     [pagination]="true"
                     [paginationPageSize]="pageSize"
                     [paginationPageSizeSelector]="[20, 50, 100, 200, 2000]"
                     [autoSizeStrategy]="autoSizeStrategy"
    />
  </div>
</div>
